/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs */

const en_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Event Gap Tolerance`)
};

const fr_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerance maximale de l'ecart d'evenement`)
};

const de_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Ereignislückentoleranz`)
};

const it_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolleranza massima del gap dell'evento`)
};

const ru_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная допустимая задержка между событиями`)
};

const es_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerancia máxima de brecha de eventos`)
};

const zh_cn2_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大事件间隙容差`)
};

const ja_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大イベントギャップ許容値`)
};

const hi_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम घटना अंतराल सहनशीलता`)
};

const pt_pt2_style_guide_manager_max_event_gap_tolerance_label = /** @type {(inputs: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerância máxima de intervalo entre eventos`)
};

/**
* | output |
* | --- |
* | "Maximum Event Gap Tolerance" |
*
* @param {Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_event_gap_tolerance_label = /** @type {((inputs?: Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Event_Gap_Tolerance_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "de") return de_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "it") return it_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "es") return es_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_max_event_gap_tolerance_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_max_event_gap_tolerance_label(inputs)
	return en_style_guide_manager_max_event_gap_tolerance_label(inputs)
});